<!--
 * @Author: 赵健
 * @Date: 2021-01-19 09:50:47
 * @LastEditTime: 2021-02-01 15:37:17
 * @LastEditors: 赵健
 * @Description: 关联会员
 * @FilePath: \Develop1.0.0\src\views\merchantCenter\equityManage\relevance.vue
-->
<template>
  <div>
    <um-bread-crumb />
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <el-card shadow="never">
        <div
          slot="header"
          class="card-header"
        >
          <span>权益名称：{{ equityName }}</span>
        </div>
        <el-form-item
          ref="equitySumNumber"
          label="享受会员:"
          prop="equitySumNumber"
        >
          <el-checkbox-group v-model="selectMemberIds">
            <el-checkbox v-for="(item,index) in memberData" :key="index" :label="item.memberLevelId">{{ item.memLevelName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div v-for="(item,index) in selectMember" :key="index" class="member-box">
          <div>{{ item.memLevelName }}</div>
          <div class="margin-t-10">
            <span>权益类型：</span>
            <el-radio-group v-model="item.equityType">
              <el-radio :label="0">会员专享</el-radio>
              <el-radio :label="1">积分兑换</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.consumptionPoints"
              style="width:150px;margin-left:10px;"
              :precision="0"
              controls-position="right"
              :min="1"
              :max="999999999"
              placeholder="请输入所需积分"
            />
          </div>
          <div class="margin-t-10">
            <span>折扣力度：</span>
            <el-radio-group v-model="item.discount">
              <el-radio :label="0">免费享受</el-radio>
              <el-radio :label="1">享受折扣</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.discountValue"
              :precision="2"
              style="width:150px;margin-left:10px;"
              controls-position="right"
              :min="0"
              :max="10"
              placeholder="请输入折扣"
            />
            <span style="margin-left:10px;">折</span>
          </div>
          <div class="margin-t-10">
            <span>使用限制：</span>
            <el-radio-group v-model="item.whetherToLimit">
              <el-radio :label="0">不限次数</el-radio>
              <el-radio :label="1">限制次数</el-radio>
            </el-radio-group>
            <el-input-number
              v-model="item.frequency"
              style="width:150px;margin-left:10px;"
              controls-position="right"
              :precision="0"
              :min="1"
              :max="999999999"
              placeholder="请输入次数"
            />
            <span style="margin-left:10px;">次/</span>
            <el-select
              v-model="item.timesUnit"
              style="width: 100px;margin-left:10px;"
              placeholder="请选择时间单位"
            >
              <el-option
                v-for="(value,key) in timeUnit"
                :key="key"
                :label="value"
                :value="key"
              />
            </el-select>
          </div>
        </div>
        <!-- <div>{{ selectMemberIds }}</div>
        <div>{{ memberData }}</div>
        <div>{{ selectMember }}</div>-->

        <el-button type="primary" style="margin: 0 auto;display: block;" @click="submitForm">确定</el-button>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import { merchantMemberAddEqConfig, merchantMemberRelateMember, merchantMemberInsertConfig } from '@/api/merchantCenter'
export default {
  name: 'MerchantEquityManageRelevance',
  data() {
    return {
      equityName: '',
      equityId: null,
      form: {},
      timeUnit: {
        0: '日',
        1: '月',
        2: '年'
      },
      memberData: [],
      selectMember: [],
      selectMemberIds: [],
      equityMemberLevelConfigurationList: []
    }
  },
  watch: {
    selectMemberIds(val) {
      this.selectMember = this.memberData.filter(i => val.includes(i.memberLevelId))
    }
  }, created() {
    this.equityId = this.$route.query.equityId
    if (!this.equityId) {
      return this.$router.go(-1)
    }
    this.getMerchantMemberAddEqConfig()
  },
  methods: {
    // 获取所有会员数据
    async getMerchantMemberAddEqConfig() {
      try {
        this.loading = true
        const res = await merchantMemberAddEqConfig()
        res.data.forEach(i => {
          i.equityType = 0 // 权益类型   0/会员   1/积分
          i.consumptionPoints = 1 // 积分数
          i.discount = 0 // 是否折扣  0 免费  1 折扣
          i.discountValue = 10 // 折扣数
          i.whetherToLimit = 0 // 是否存在次数限制   1 是  0 否
          i.frequency = 1 // 次数
          i.timesUnit = '0' // 时间单位 天0月1年2
        })
        this.memberData = res.data
        // 必须得到所有会员数据才能回显
        this.getMerchantMemberRelateMember()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    // 获取当前回显数据
    async getMerchantMemberRelateMember() {
      try {
        this.loading = true
        const res = await merchantMemberRelateMember({ equityId: this.equityId })
        // 权益名回显
        this.equityName = res.data.equityManagementRecordVo.equityName
        // 上面多选框回显
        this.selectMemberIds = res.data.memberLevelIdList
        // 下面会员列表回显
        this.memberData.forEach(i => {
          res.data.equityMemberLevelConfigurationList.forEach(j => {
            if (i.memberLevelId == j.memberLevelId) {
              i.id = j.id
              i.memberLevelId = j.memberLevelId
              i.equityType = j.equityType
              i.consumptionPoints = j.consumptionPoints
              i.discountValue = j.discountValue
              i.whetherToLimit = j.whetherToLimit
              i.frequency = j.frequency
              i.timesUnit = j.timesUnit ? j.timesUnit + '' : '0'
              i.discount = j.discount
            }
          })
        })

        // this.selectMember = res.data.equityMemberLevelConfigurationList.map(i => (
        //   {
        //     id: i.id,
        //     memberLevelId: i.memberLevelId,
        //     equityType: i.equityType,
        //     consumptionPoints: i.consumptionPoints,
        //     discountValue: i.discountValue,
        //     whetherToLimit: i.whetherToLimit,
        //     frequency: i.frequency,
        //     timesUnit: i.timesUnit,
        //     discount: i.discount
        //   }
        // ))
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    async submitForm() {
      try {
        this.loading = true
        await merchantMemberInsertConfig({
          equityId: this.equityId,
          equityMemberLevelConfigurationList: this.selectMember.map(
            i => ({
              id: i.id,
              memberLevelId: i.memberLevelId,
              equityType: i.equityType,
              consumptionPoints:
                      i.equityType == 1 ? i.consumptionPoints : undefined,
              discount: i.discount,
              discountValue:
                      i.discount == 1 ? i.discountValue : undefined,
              whetherToLimit: i.whetherToLimit,
              frequency: i.whetherToLimit == 1 ? i.frequency : undefined,
              timesUnit: i.whetherToLimit == 1 ? i.timesUnit : undefined
            })
          )
        })
        this.$message.success('操作成功!')
        this.$router.go(-1)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.member-box{
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #918b8b;
  margin-bottom: 20px;
}
</style>
